<template>
  <div>
    <div class="vx-row no-gutter items-center justify-center">
      <component
        :is="currentStepComponent"
        v-if="currentStepComponent"
        :onboarding-step-data="onboardingStepData"
        @updated="getInvestorOnboardingData"
      />
    </div>
  </div>
</template>

<script>
const InvestorOnboardingPhone = () => import("@views/investor/onboarding/InvestorOnboardingPhone.vue");
const InvestorOnboardingName = () => import("@views/investor/onboarding/InvestorOnboardingName.vue");
const InvestorOnboardingBirthData = () => import("@views/investor/onboarding/InvestorOnboardingBirthData.vue");
const InvestorOnboardingGender = () => import("@views/investor/onboarding/InvestorOnboardingGender.vue");
const InvestorOnboardingRfcCurp = () => import("@views/investor/onboarding/InvestorOnboardingRfcCurp.vue");
const InvestorOnboardingAddressData = () => import("@views/investor/onboarding/InvestorOnboardingAddressData.vue");
const InvestorOnboardingOccupation = () => import("@views/investor/onboarding/InvestorOnboardingOccupation.vue");
const InvestorOnboardingKycProfile = () => import("@views/investor/onboarding/InvestorOnboardingKycProfile.vue");
const InvestorOnboardingCheckData = () => import("@views/investor/onboarding/InvestorOnboardingCheckData.vue");
const InvestorOnboardingIdentityVerification = () => import("@views/investor/onboarding/InvestorOnboardingIdentityVerification.vue");
const InvestorOnboardingRiskAcceptanceV3 = () => import("@views/investor/onboarding/InvestorOnboardingRiskAcceptanceV3.vue");
const InvestorOnboardingMerchantContractV2 = () => import("@views/investor/onboarding/InvestorOnboardingMerchantContractV2.vue");
const InvestorOnboardingReceiptPayments = () => import("@views/investor/onboarding/InvestorOnboardingReceiptPayments.vue");
const InvestorOnboardingAutomaticInvestment = () => import("@views/investor/onboarding/InvestorOnboardingAutomaticInvestment.vue");

const STEP_COMPONENT_MAP = {
  "1_signup": "InvestorOnboardingPhone",
  "2_cellphone_checked": "InvestorOnboardingName",
  "3_name": "InvestorOnboardingBirthData",
  "4_birth_data": "InvestorOnboardingGender",
  "5_gender": "InvestorOnboardingRfcCurp",
  "6_rfc_curp": "InvestorOnboardingAddressData",
  "6_1_address": "InvestorOnboardingOccupation",
  "7_occupation": "InvestorOnboardingKycProfile",
  "8_kyc_profile": "InvestorOnboardingCheckData",
  "9_data_check": "InvestorOnboardingRiskAcceptanceV3",
  "10_risk_acceptance": "InvestorOnboardingMerchantContractV2",
  "11_merchant_contract": "InvestorOnboardingReceiptPayments",
  "12_receipt_payments": "InvestorOnboardingAutomaticInvestment",
};

const IDENTITY_VERIFICATION_STEPS = ["9_data_check", "10_risk_acceptance", "11_merchant_contract", "12_receipt_payments"];

export default {
  name: "InvestorMainOnboardingStepPagePf",
  props: ["onboardingStepData"],
  components: {
    InvestorOnboardingPhone,
    InvestorOnboardingName,
    InvestorOnboardingBirthData,
    InvestorOnboardingGender,
    InvestorOnboardingRfcCurp,
    InvestorOnboardingAddressData,
    InvestorOnboardingOccupation,
    InvestorOnboardingKycProfile,
    InvestorOnboardingCheckData,
    InvestorOnboardingIdentityVerification,
    InvestorOnboardingRiskAcceptanceV3,
    InvestorOnboardingMerchantContractV2,
    InvestorOnboardingReceiptPayments,
    InvestorOnboardingAutomaticInvestment,
  },
  computed: {
    currentOnboardingStep(){
      return this.onboardingStepData.onboarding_step;
    },
    showIdentityVerification(){
      return IDENTITY_VERIFICATION_STEPS.includes(this.currentOnboardingStep)
        && (this.onboardingStepData.identity_verification_status === 4
          || this.onboardingStepData.identity_verification_status === 5
          || this.onboardingStepData.identity_verification_status === null);
    },
    currentStepComponent(){
      if (this.showIdentityVerification) {
        return "InvestorOnboardingIdentityVerification";
      }
      return STEP_COMPONENT_MAP[this.currentOnboardingStep] || null;
    },
  },
  methods: {
    getInvestorOnboardingData(){
      this.$emit("updated", 1);
    }
  }
}
</script>
